import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Input, useInput, Card, Spacer, Text, Grid, Button } from "@nextui-org/react";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import './OrderViewEdit.css'; // Import the CSS file

const Recipient = ({ recipient, editable, handleRecipientChange }) => {

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedRecipient = { ...recipient, [name]: value };
    handleRecipientChange(updatedRecipient);
  };

  const { value, reset, bindings } = useInput("");

  const helper = React.useMemo(() => {
    if (!value)
      return {
        text: "",
        color: "",
      };
  }, [value]);

  return (

    <>
      {editable ||(recipient.name && recipient.name !== '') || (recipient.age && recipient.age !== '') ? <div style={{ 
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                    paddingLeft: '1rem',
                    paddingRight: '1rem',
                    border: '1px solid #eaeaea',
                    borderRadius: '10px',
                    background: 'black',
                    marginBottom: '0.5rem',
                    marginTop: '0.5rem',
                    marginLeft: '0.5rem',
                    marginRight: '0.5rem',
                    textAlign: 'center',
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    color: 'white',
                    //letter spacing
                    letterSpacing: '0.15rem',
                    marginTop: '10px'
                  }}>

        <strong>Recipient Details</strong>
      </div>
        :
        null
      }
      <Grid.Container gap={2}>
        <Grid>
          {editable || (recipient.name && recipient.name !== '') ?
            editable ?
              <EditableField
                label="Name"
                name="name"
                value={recipient.name}
                onChange={handleInputChange}
              /> :
              <NonEditableField label="Name" value={recipient.name} />
            : null
          }
        </Grid>
        <Grid>
          {editable || (recipient.age && recipient.age !== '') ?
            editable ?
              <EditableField
                label="Age"
                name="age"
                value={recipient.age}
                onChange={handleInputChange}
              /> :
              <NonEditableField label="Age" value={recipient.age} />
            : null
          }
        </Grid>
      </Grid.Container>
    </>


  );
};

export default Recipient;

const EditableField = ({ label, value, onChange, options, name, type = 'text', ...props }) => {

  return (
    <div className="field">
      <div style={{ display: 'flex',flexDirection: 'column', }}>
      <>{label}{' '}</>
      {type === 'text' && (
        <InputText name={name} value={value} onChange={onChange} {...props} />
      )}
      {type === 'calendar' && (
        <Calendar
          value={new Date(value)}
          onChange={onChange}
          name={name}
          {...props}
        />
      )}
      {type === 'dropdown' && (
        <Dropdown
          value={value}
          options={options}
          onChange={(e) => onChange(e, name)}
          placeholder={`Select a ${label}`}
          filter
          {...props}
        />
      )}
      </div>
    </div>
  );
}

const NonEditableField = ({ label, value }) => (
  <div className="field">
    <strong><label>{label}</label></strong>
    <div>{value}</div>
  </div>
);


// <Panel header="Recipient Details">
// <div>
//   <b>Name:</b>{' '}
//   {editable ?
//     <InputText name="name" value={recipient.name} onChange={handleInputChange} /> :
//     recipient.name}
// </div>
// <div>
//   <b>Age:</b>{' '}
//   {editable ?
//     <InputText name="age" value={recipient.age} onChange={handleInputChange} /> :
//     recipient.age}
// </div>
// </Panel>